import { render, staticRenderFns } from "./NamedSection.vue?vue&type=template&id=561c79f8&scoped=true&"
import script from "./NamedSection.vue?vue&type=script&lang=ts&"
export * from "./NamedSection.vue?vue&type=script&lang=ts&"
import style0 from "./NamedSection.vue?vue&type=style&index=0&id=561c79f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c79f8",
  null
  
)

export default component.exports